import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import SideBarMain from "../../components/cm/SideBarMain";
import { MainNavBarEnum } from "../../components/cm/SideBarMain/MainNavBarEnum";
import AISummary from "../../components/modules/ai-summary/AISummary";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.AI_SUMMARY} />}>
      <AISummary/>
    </AppWrapper.WithSidebar>
  );
};
